{
  "manual": {
    "helpUrl": "https://help.family-album.com/hc/categories/52544526505497",
    "supportEmail": "support@mitene.us",
    "title": "取扱説明書",
    "headerTitle": "取扱説明書",
    "hero": {
      "welcome": "ようこそ\nみてねおもいでフォトフレームへ",
      "description": "みてねに残した、あの日の笑顔が\nふとしたときに、目の前によみがえります。\n大切な思い出を\nご家族みんなでお楽しみください。\n\nこの取扱説明書には、\nセットアップの手順から主な機能、\nサポート情報まで、はじめに必要なことが\nすべてまとまっています。\nよくある質問・最新情報については、\nサポートページをご覧ください。",
      "descriptionPC": "みてねに残した、あの日の笑顔が\nふとしたときに、目の前によみがえります。\n大切な思い出を\nご家族みんなでお楽しみください。\n\nこの取扱説明書には、\nセットアップの手順から主な機能、サポート情報まで、\nはじめに必要なことがすべてまとまっています。\nよくある質問・最新情報については、サポートページをご覧ください。",
      "helpCenter": "サポートページはこちら"
    },
    "tableOfContents": {
      "quickStart": "かんたんセットアップガイド",
      "basicOperation": "基本の使いかた",
      "specifications": "製品仕様",
      "legal": "法令適合・製品に関する重要なお知らせ",
      "safety": "安全上のご注意",
      "warranty": "保証とサポート"
    },
    "section1": {
      "title": "かんたんセットアップガイド",
      "intro": "4ステップで、すぐに使えます\n同梱品：本体、かんたんセットアップガイド、電源ケーブル、サポートスタンド",
      "step1": {
        "title": "1. 電源をつないで、Wi-Fiに接続",
        "description": "電源ケーブルを差し込むと、画面が立ち上がります。表示される案内にそって、Wi-Fiを設定してください。"
      },
      "step2": {
        "title": "2. みてねアカウントと連携",
        "description": "フレームに表示されるQRコードを、みてねアプリが入ったスマートフォンで読み取るだけで連携できます。\nまたは、フレーム上でメールアドレスとパスワードを入力してログインすることもできます。\nログイン後、フレームを見分けやすくするために名前をつけましょう。（例：リビング、おばあちゃんの家）\nまだみてねアプリをお持ちでない方は、App Store または Google Play から「みてね」をダウンロードしてください。",
        "downloadLink": "ダウンロードはこちら"
      },
      "step3": {
        "title": "3. アルバムをえらんで表示",
        "description": "フレームで見たいアルバムを選んで、写真や動画の種類をえらびましょう。（あとからいつでも変更できます）"
      },
      "step4": {
        "title": "4. みてねと自動でつながる",
        "description": "みてねアプリの写真や動画が、自動でフレームに届きます。リビングやお部屋で、ご家族みんなと一緒にお楽しみください。"
      },
      "contact": {
        "title": "お問い合わせ",
        "helpCenter": "サポートページはこちら",
        "contactLabel": "メールはこちら："
      }
    },
    "section2": {
      "title": "基本の使いかた",
      "overview": {
        "title": "ご利用にあたって",
        "description": "みてねおもいでフォトフレームをご利用いただくには、「みてね」アプリとWi-Fi接続が必要です。\nこのページでは、セットアップの流れから主な機能、安全上のご注意、サポート情報までをまとめています\nフレームの表示方法、スライドショーの再生時間、スリープモードのスケジュールなどは、すべてアプリからいつでもかんたんに調整できます。\nまだアプリをお持ちでない方は、App Store または Google Play から「みてね」をダウンロードしてください\nすでにアカウントをお持ちの方は、セットアップ時に連携するだけで、写真や動画が自動で同期されます。"
      },
      "powerOn": {
        "title": "電源の入れ方・切り方",
        "description": "付属の電源ケーブルを接続すると、自動的に電源が入り、セットアップ画面が表示されます。\n電源ポート（A）と電源ボタン（B）はフレーム背面にあります。"
      },
      "powerOff": {
        "title": "電源を切る方法",
        "description": "推奨：みてねアプリからリモート操作で電源をオフ、またはスリープスケジュールを設定できます。\nフレームの画面をタップして「設定メニュー」からスリープモードをすぐにオンにすることも可能です。スリープモードの設定で「画面をオフにする」を選択している場合は、即時に画面を消灯できます\n背面の電源ボタンを長押ししてオフにすることもできます（起動時間が長くなる場合があります）。"
      },
      "operation": {
        "title": "フレームの操作",
        "description": "タッチパネルで直感的に操作できます。\n画面をタップするとメニューが開き、左右にスワイプすると写真や動画を切り替えられます。\n基本的な設定はフレーム上でも可能ですが、詳細設定はアプリからの操作をおすすめします。"
      },
      "wifi": {
        "title": "Wi-Fi 接続",
        "description": "画面に表示される案内にそって、ご家庭のWi-Fiネットワークを選び、パスワードを入力してください。\n接続が完了すると、セットアップを続けられます。\nWi-Fi接続後、性能およびセキュリティを維持するために、自動的にソフトウェアアップデートが行われる場合があります。",
        "noteTitle": "⚠️ ご注意",
        "note": "本製品は 2.4GHz（IEEE 802.11 b/g/n）のWi-Fiに対応しています。5GHz には対応していません。\nインターネット接続が必須です。Wi-Fiが切断された状態が7日以上続くと、アプリの写真や動画が表示されなくなります。\n長期間ご利用になる際は、常にWi-Fiに接続した状態でお使いください。"
      },
      "account": {
        "title": "みてねアカウントとの連携",
        "description": "画面の案内にそってアカウントと連携します。方法は2通りです。",
        "option1Title": "① QRコードを使う方法",
        "option1": "フレームに表示されるQRコードを、みてねアプリが入ったスマートフォンで読み取る。\nフォトフレームに表示された確認コードが、アプリ上で表示されているコードと一致していることを確認し、「承認する」をタップします。承認後、自動的にフォトフレームの画面が切り替わります。",
        "option2Title": "② メールアドレスとパスワードを入力する方法",
        "option2": "フレーム上でメールアドレスとパスワードを入力します。\nメールで届く確認コードを入力して完了です。\nまだアカウントをお持ちでない方は、App Store または Google Play から「みてね」をダウンロードしてアカウントを作成してください。\nみてねアプリの詳しい使いかたについては、サポートページをご覧ください"
      },
      "mediaSelection": {
        "title": "写真・動画の選択",
        "description": "フレームに表示する写真や動画は、みてねアプリからもコントロールできます。\nセットアップ時に表示方法を選べるほか、あとからいつでもアプリ上で変更可能です。"
      },
      "displaySettings": {
        "title": "表示のカスタマイズ",
        "description": "フレームの画面をタップすると「設定メニュー」が開きます。\n設定メニューのオプションより、フレームに表示するアルバム、写真や動画、スライドショーの速度、表示順序、時計の表示、明るさや音量などを変更できます。\nこれらはみてねアプリからもリモートで調整できます。"
      },
      "sleep": {
        "title": "スリープモード",
        "description": "夜は画面をオフにし、朝に自動でオンにするスケジュールを設定できます。\nスリープ中に時計を表示することも、画面を消し真っ暗にすることも可能です。\nフレームをタップすると、すぐにスリープを解除できます。"
      },
      "reset": {
        "title": "初期化（ファクトリーリセット）",
        "intro": "必要に応じてフレームを初期状態に戻すことができます。方法は3通りです。",
        "description": "フレームの「設定メニュー」から「初期化」を選び、画面の案内に従う\n背面の電源ボタンを長押しし、リセット画面から操作\nみてねアプリの「設定」タブからリモートで初期化",
        "noteTitle": "⚠️ ご注意：",
        "note": "初期化すると設定がすべて消去され、アカウントとの連携も解除されます。\n必要な場合のみ実行してください。"
      }
    },
    "section3": {
      "title": "製品仕様",
      "productName": {
        "title": "製品名",
        "value": "みてねおもいでフォトフレーム"
      },
      "display": {
        "title": "ディスプレイ",
        "value": "10.1インチ IPS タッチスクリーン（1280 × 800 解像度、16:10）"
      },
      "wifi": {
        "title": "Wi-Fi 専用",
        "value": "IEEE 802.11 b/g/n（2.4GHz のみ対応） Bluetooth 非対応"
      },
      "ports": {
        "title": "接続・ポート",
        "value": "USB-C ポート（利用不可）\nSDカードスロット（利用不可）\nDC電源入力"
      },
      "storage": {
        "title": "ストレージと対応メディア",
        "value": "内蔵ストレージ 32GB（約25,000枚の写真保存が可能）\n一般的な写真・動画・音声フォーマットに対応"
      }
    },
    "section4": {
      "title": "法令適合・製品に関する重要なお知らせ",
      "radioLaw": {
        "title": "電波法適合（技術基準適合証明／工事設計認証）",
        "description": "本製品は電波法に基づく技術基準に適合しています。\n技適マークおよび認証番号は、フレームの画面をタップし「設定メニュー」→「一般設定」→「この製品について」から確認できます。"
      },
      "radioExposure": {
        "title": "電波曝露",
        "description": "本製品は電波に関する安全基準に適合しています。\nご使用時は、人体との距離を20cm以上あけて設置してください。\n他の電波を発する機器を近接させないようにしてください。\n植込み型心臓ペースメーカーやICDなど医療用電気機器の近くでは使用しないでください。"
      },
      "intendedUse": {
        "title": "使用目的",
        "description": "本製品は家庭用・屋内専用です。業務用途や屋外では使用しないでください。\n必ず付属の電源アダプターをご使用ください。\n安全上の注意事項を守らない場合、故障やけが、保証対象外となる場合があります。"
      },
      "environment": {
        "title": "環境への配慮",
        "description": "本製品は廃棄の際、一般家庭ごみとして捨てず、各自治体の指示に従って適切に処理してください。\n小型家電リサイクル法など、電子機器リサイクル制度をご利用ください。"
      },
      "manufacturer": {
        "title": "販売者・製造者情報",
        "description": "販売元：株式会社MIXI\n製造元：JENESIS株式会社　東京都千代田区神田司町2-8-1 PMO神田司町7F"
      }
    },
    "section5": {
      "title": "安全上のご注意",
      "overview": {
        "description": "ご使用にあたっては、下記の安全上の注意を必ずお読みいただき、正しくお使いください。\n⚠️ 注意事項を守らない場合、感電・火災・故障などの原因となります。\n誤使用や改造による損害は、保証の対象外となります。"
      },
      "childSafety": {
        "title": "乳幼児・お子さまの安全について",
        "description": "本製品はおもちゃではありません。フレームおよび付属品（電源ケーブルや梱包材など）は、乳幼児や小さなお子さまの手の届かない場所で使用・保管してください。\nベビーベッドやお子さまの寝る場所、手が届く場所には絶対に設置しないでください。\n電源ケーブルは、つまずき・引っ張り・かじりつき・からまりを防ぐため、お子さまの通る場所に置かないでください。\n梱包材のビニール袋や小さな部品は、窒息や誤飲の危険があります。梱包材は開封後すぐに廃棄し、小さな部品はお子さまの手の届かない場所に保管してください。\n必ず大人の管理のもとでご使用ください。家具の上などに置き、お子さまがよじ登って触れることで、落下やけがの危険がないようにしてください。\n本製品の上に乗ったり、物を置いたり、家具を支える台として使ったりしないでください。写真や動画を表示する以外の用途に使用すると、本製品が倒れるなどして、本製品や周囲の物が壊れる危険や、近くにいる人がけがをする危険があります。\nフレームや画面が破損した場合は、ガラス片や鋭い部分に触れず、直ちに使用を中止してください。",
        "note": "⚠️ お子さまの近くでの不適切な設置や使用は、けがや事故につながるおそれがあります。必ず本ガイドラインをお守りください。"
      },
      "electricalSafety": {
        "title": "電気の安全について",
        "description": "必ず付属の電源アダプターをご使用ください。\n電源コードやプラグが破損・異常な場合は使用しないでください。\n電源アダプターを熱源や水分の近くに置かないでください。\n雷が鳴っているときや長期間使用しないときは、電源プラグを抜いてください。\nプラグの抜き差しは必ずプラグ本体を持って行ってください。濡れた手で触れないでください。"
      },
      "fireSafety": {
        "title": "火災・高温に関する注意",
        "description": "通気口をふさがないでください。\n高温になる場所（炎天下車内、火や暖房器具のそば、直射日光が当たる場所、サウナなど）での使用、放置、保管はしないでください。 本製品の推奨動作温度は０℃～45℃です。\n本製品の推奨動作温度は０℃～45℃です。\n使用中に布や紙などで覆わないでください。\n壁際・家具に密着させず、周囲に十分な空間を確保してください。\n使用中に異臭・異音・発熱・変色・変形などの異常を感じた場合は、すぐに電源を切り、プラグを抜き、サポート窓口へご連絡ください。"
      },
      "moistureSafety": {
        "title": "水分・湿気に関する注意",
        "description": "雨天、降雪中、プール、海、風呂場、シャワー室などの水がかかる場所や、多湿の場所での使用、放置、保管はしないでください。\n水などの液体を本体の近くに置かないでください。\n食卓やキッチンなど、飲食物のこぼれや湯気・油煙が発生しやすい場所では使用しないでください。飲料や食べかすが内部に入ると、感電・火災・故障の原因となり、また、腐食や誤作動を引き起こすおそれがあります。\n水分などが内部に入った場合は、すぐに電源を切り、プラグを抜き、サポート窓口へご連絡ください。"
      },
      "maintenance": {
        "title": "メンテナンス・お手入れについて",
        "description": "分解や修理は行わないでください。\nお手入れの際は、柔らかい乾いた布で画面を軽く拭いてください。\n水・洗剤・アルコール・研磨剤入りのクリーナーは使用しないでください。"
      }
    },
    "section6": {
      "title": "保証とサポート",
      "warranty": {
        "title": "保証について",
        "description": "本製品には、ご購入日から1年間の保証がついています。\n保証は、通常のご使用において発生した材料または製造上の不具合を対象としています。\n保証対応の際には、ご購入日を確認できる書類（レシートなど）が必要となる場合があります。"
      },
      "warrantyExclusions": {
        "title": "保証の対象外",
        "intro": "以下の場合は保証の対象外となります：",
        "exclusions": "誤使用、事故、または無断改造による損傷\n落雷や異常電圧、水こぼれや湿気による損傷\n外観上のキズや摩耗などの経年劣化\n正規販売店以外からの購入品",
        "note": "⚠️ 安全上の注意に従わず使用した場合の損害は、保証の対象外となることがあります。"
      },
      "support": {
        "title": "サポートのご案内",
        "description": "製品に関するご不明点や不具合があった場合は、下記までお問い合わせください。\nセットアップ方法からトラブルシューティング、保証に関するご質問まで、サポートチームが対応いたします。",
        "helpCenter": "サポートページはこちら",
        "contactLabel": "メールはこちら："
      }
    }
  }
}
